export class LeaseApplicationError extends Error {
  constructor(
    message = 'Lease application failed',
    public cause?: unknown,
  ) {
    super(message);
    this.name = 'LeaseApplicationError';
  }
}
